<nz-layout class="content-default-size">
  <nz-header class="bg-white border-bottom">
    <nz-space>
      <p *nzSpaceItem class="text-black-50" i18n="@@referenceData.header.name">
        Reference data
      </p>
    </nz-space>
  </nz-header>
  <nz-content class="h-100 bg-white mx-2">
    <div nz-row class="h-100">
      <div nz-col nzSpan="24" class="bg-light">
        <nz-tabset nzType="card" [nzSelectedIndex]="selectedTab">
          <nz-tab *ngFor="let tab of LIST_OF_REFERENCES">
            <a *nzTabLink nz-tab-link [routerLink]="[tab.slug]">
              {{ language === "EN" ? tab.nameEn : tab.nameRu }}
            </a>
          </nz-tab>
        </nz-tabset>
        <router-outlet></router-outlet>
      </div>
    </div>
  </nz-content>
  <!-- <nz-footer></nz-footer> -->
</nz-layout>
